<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn small flat v-on="on" class="mx-2">
        <v-icon small class="mr-2">view_list</v-icon>
        {{ selectedLabel }}
        <v-icon small right>arrow_drop_down</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-tile v-for="view in views" :key="view.id" @click="$emit('input', view.id)">
        <v-list-tile-action><v-icon small>{{ view.icon }}</v-icon></v-list-tile-action>
        <v-list-tile-title>{{ view.label }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: { value: { type: String, default: 'standard' } },
  data: () => ({
    views: [
      { id: 'standard', label: 'Standard view', icon: 'view_list' },
      { id: 'texts', label: 'Texts view', icon: 'subject' },
      { id: 'netx_images', label: 'NetX images', icon: 'photo_library' },
    ],
  }),
  computed: {
    selectedLabel() {
      const selected = this.views.find(view => view.id === this.value)
      return selected ? selected.label : 'Standard view'
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/artworks/ArtworkRowViewMenu.vue